module.exports = __webpack_public_path__ + "static/media/Calendar.0a6ffb30.png";